import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import { api } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Input } from "@/components/ui/input";
import { MagnifyingGlass } from "@phosphor-icons/react";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState("");

  const search = useCallback(async (q) => {
    setLoading(true);
    const params = q ? `?q=${encodeURIComponent(q)}` : "";
    try {
      const { data } = await api.get(`/blog${params}`);
      setPosts(data);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { search(""); }, [search]);

  const onSubmit = (e) => { e.preventDefault(); search(query); };

  const renderList = () => {
    if (loading) return <div className="text-slate-500">Loading…</div>;
    if (posts.length === 0) return <div className="text-slate-500" data-testid="blog-empty">No posts match "{query}". Try another keyword.</div>;
    return (
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="blog-list">
        {posts.map((p) => (
          <Link key={p.slug} to={`/blog/${p.slug}`} className="rounded-lg border tf-hairline bg-white p-6 hover:-translate-y-0.5 hover:shadow-sm transition-transform" data-testid={`blog-item-${p.slug}`}>
            <div className="flex flex-wrap gap-1">
              {(p.tags || []).map((t) => (
                <Badge key={t} variant="secondary" className="text-[10px] uppercase tracking-wider">{t}</Badge>
              ))}
            </div>
            <h3 className="mt-4 font-[Chivo] text-xl font-bold text-[#0A2540] leading-snug">{p.title}</h3>
            <p className="mt-3 text-sm text-slate-600 line-clamp-3">{p.excerpt}</p>
            <div className="mt-6 text-xs text-slate-500 font-mono uppercase tracking-widest">{p.author}</div>
          </Link>
        ))}
      </div>
    );
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <section className="border-b tf-hairline bg-white">
        <div className="mx-auto max-w-7xl px-6 lg:px-8 py-16">
          <div className="text-xs font-mono uppercase tracking-widest text-[#D32F2F]">Insights</div>
          <h1 className="mt-3 font-[Chivo] text-5xl lg:text-6xl font-black text-[#0A2540] tracking-tight">Tax intelligence for modern practitioners.</h1>
          <p className="mt-5 max-w-2xl text-lg text-slate-600">Playbooks, IRS updates and quiet-quitting-friendly explainers from the Taxfree Filer editorial desk.</p>
          <form onSubmit={onSubmit} className="mt-8 max-w-md flex gap-2" data-testid="blog-search-form">
            <div className="relative flex-1">
              <MagnifyingGlass size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
              <Input value={query} onChange={(e) => setQuery(e.target.value)} placeholder="Search FBAR, ITIN, CP2000…" className="pl-9" data-testid="blog-search-input" />
            </div>
            <button type="submit" className="px-4 rounded-md bg-[#0A2540] text-white text-sm font-medium" data-testid="blog-search-submit">Search</button>
          </form>
        </div>
      </section>
      <section className="mx-auto max-w-7xl px-6 lg:px-8 py-16">
        {renderList()}
      </section>
      <Footer />
    </div>
  );
}
